import Swiper from 'swiper';

import 'swiper/swiper.scss';

(() => {
    const serviceCarousels = document.querySelectorAll('[data-service-carousel]');

    Array.from(serviceCarousels).map((serviceCarousel) => {
        // eslint-disable-line no-new
        new Swiper(serviceCarousel, {
            centeredSlidesBounds: true,
            observer: true,
            loop: false,
            observeSlideChildren: true,
            slideToClickedSlide: true,
            watchOverflow: true,
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                640: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
            },
            on: {
                init: () => {
                    console.log('iets');
                },
                slideChange: (swiper) => {
                    console.log(swiper);
                },
                sliderMove: () => {
                    console.log('hela');
                },
            }
        });
    });
})();

